module.exports = __webpack_public_path__ + "img/r-105.9c503270.jpg";